// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__C1G7J","search":"Settings_search__3wcWJ","filter":"Settings_filter__1fK7d"};